import type { Theme } from '@mui/material';

const customShadows = (): Theme['customShadows'] => {
  const color = `var(--mui-palette-mainShadowChannel)`;
  return {
    // Standard elevation shadows
    xs: `0px 2px 4px rgb(${color} / 0.18)`,
    sm: `0px 3px 6px rgb(${color} / 0.2)`,
    md: `0px 4px 10px rgb(${color} / 0.22)`,
    lg: `0px 6px 16px rgb(${color} / 0.24)`,
    xl: `0px 8px 28px rgb(${color} / 0.26)`,

    // Panel/card shadows (commonly used for poppers, drawers, panels)
    panel: `0px 10px 30px 0px rgb(${color} / 0.10)`,
    panelMd: `0px 10px 30px 0px rgb(${color} / 0.20)`,
    panelLg: `0px 10px 30px 0px rgb(${color} / 0.25)`,

    // Inverted shadows (shadow going up, for footers/bottom bars)
    panelUp: `0px -5px 30px 0px rgb(${color} / 0.10)`,
    panelUpMd: `0px -10px 30px 0px rgb(${color} / 0.25)`,

    // Focus ring shadow (for slider thumbs, buttons)
    focusRing: `0 0 0 2px rgb(${color} / 0.12)`,

    // Composite shadow (search bar style)
    input: `0 9px 9px 0px rgb(${color} / 0.01), 0 2px 5px 0px rgb(${color} / 0.06)`,
  };
};

export { customShadows };
